var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupArtIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 164.907,
    viewBox: "0 0 320 164.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_ART",
    transform: "translate(-640 -280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4400",
    "data-name": "Group 4400",
    transform: "translate(-531.826 -2836.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_group_video_re_btu7",
    transform: "translate(1171.826 3116.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M435.455,422.66h-196.7a8.179,8.179,0,0,1-8.17-8.17V273.368a8.179,8.179,0,0,1,8.17-8.17h196.7a8.179,8.179,0,0,1,8.17,8.17V414.49A8.179,8.179,0,0,1,435.455,422.66ZM238.754,269.5a3.874,3.874,0,0,0-3.87,3.87V414.49a3.874,3.874,0,0,0,3.87,3.87h196.7a3.874,3.874,0,0,0,3.87-3.87V273.368a3.874,3.874,0,0,0-3.87-3.87Z",
    transform: "translate(-230.584 -264.745)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M437.851,423.121H241.15a6.242,6.242,0,0,1-6.235-6.235V275.764a6.242,6.242,0,0,1,6.235-6.235h196.7a6.242,6.242,0,0,1,6.235,6.235V416.886A6.242,6.242,0,0,1,437.851,423.121Z",
    transform: "translate(-232.98 -267.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ab6171fa-7d69-4734-b81c-8dff60f9761b",
    cx: 20.82,
    cy: 20.82,
    r: 20.82,
    transform: "translate(84.737 48.205)",
    fill: "#ffe5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bf427902-b9bf-4946-b5d7-5c1c7e04535e",
    d: "M411.411,357.707c.157-2.391,1.739-4.838,6.762-6.116,0,0,8.621-11.024,20.337-5.243,0,0,5.68-.977,9.891,4.916,0,0,4.176-2.463,5.937,1.9,0,0,4.9,8.9,3.094,17.985s-2.726,10.215-2.726,10.215,2.3-18.785-10.938-17.483-23.893-3.352-26.89,6.839c-2.489,8.463-2.175,12.858-2.175,12.858s-8.323-8.442-5.493-15.09A32.862,32.862,0,0,0,411.411,357.707Z",
    transform: "translate(-329.079 -308.712)",
    fill: "#413f42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M340.121,541.462H455.285c-.77-8.785-1.273-15.32-1.273-17.531,0-9.748-7.976-20.386-7.976-20.386l-2.855-1.578-23.843-7.439-6.17-8.015a6.862,6.862,0,0,0-5.5-2.683l-19.491.146a6.882,6.882,0,0,0-4.622,1.832l-12.07,11.2-17.7,8.453-.03-.03-.185.138-2.627,1.892-1.69,1.221s-4.433,5.319-7.976,21.271A78.579,78.579,0,0,0,340.121,541.462Z",
    transform: "translate(-291.182 -385.698)",
    fill: "#fada9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M837.142,557.387H771.5a8.179,8.179,0,0,1-8.17-8.17V504.26a8.179,8.179,0,0,1,8.17-8.17h65.641a8.179,8.179,0,0,1,8.17,8.17v44.958A8.179,8.179,0,0,1,837.142,557.387Zm-65.641-57a3.874,3.874,0,0,0-3.87,3.87v44.958a3.874,3.874,0,0,0,3.87,3.87h65.641a3.874,3.874,0,0,0,3.87-3.87V504.26a3.874,3.874,0,0,0-3.87-3.87Z",
    transform: "translate(-525.312 -392.48)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M839.538,557.848H773.9a6.242,6.242,0,0,1-6.235-6.235V506.655a6.242,6.242,0,0,1,6.235-6.235h65.641a6.242,6.242,0,0,1,6.235,6.235v44.958A6.242,6.242,0,0,1,839.538,557.848Z",
    transform: "translate(-527.708 -394.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M846.359,524.449c.38-2.367-.694-4.11-3.541-5.094-2.832-2.457-7.017-3.047-9.529.889a3.942,3.942,0,0,0-4.155,3.531c-2.307,2.682.255,12.526,1.014,16.277l4.05-.04,8.086-.08,4.075-.04,1.553-8.8A5.539,5.539,0,0,0,846.359,524.449Z",
    transform: "translate(-561.194 -404.27)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M841.751,594.461a19.51,19.51,0,0,1,3.346-1.708L833.58,579.078l-7.611-1.948q-.093-.052-.185-.108l-12.84.492-.055-.055-8.1,3.961-11.517,13.315a19.379,19.379,0,0,1,3.261,1.648l-1.189,4.52h8.241l2.193-3.187h.11c0-.055.005-.11.005-.165l1.538-2.237q.052,2.712-.14,5.589h25.631c-.04-1.593-.05-3.177-.05-4.75l2.867,4.16c.215-.315.444-.609.674-.909l.564,1.5h6.563l-1.573-5.983A1.4,1.4,0,0,0,841.751,594.461Z",
    transform: "translate(-541.878 -437.254)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M837.142,325.482H771.5a8.179,8.179,0,0,1-8.17-8.17V272.355a8.179,8.179,0,0,1,8.17-8.17h65.641a8.179,8.179,0,0,1,8.17,8.17v44.958A8.179,8.179,0,0,1,837.142,325.482Zm-65.641-57a3.874,3.874,0,0,0-3.87,3.87v44.957a3.874,3.874,0,0,0,3.87,3.87h65.641a3.874,3.874,0,0,0,3.87-3.87V272.355a3.874,3.874,0,0,0-3.87-3.87Z",
    transform: "translate(-525.312 -264.185)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M839.538,325.943H773.9a6.242,6.242,0,0,1-6.235-6.235V274.751a6.242,6.242,0,0,1,6.235-6.235h65.641a6.242,6.242,0,0,1,6.235,6.235v44.958A6.242,6.242,0,0,1,839.538,325.943Z",
    transform: "translate(-527.708 -266.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M835.248,300.086a8.638,8.638,0,0,0,16.894,1.553c.28-.291,3.38-3.6,2.258-6.24a13.637,13.637,0,0,1-.914-4.476c-.065-.992-.722-2.008-2.807-2.538,0,0-3.578-4.576-8.44-2.176a4.4,4.4,0,0,0-4.105,2.04,1.641,1.641,0,0,0-2.464.79,12.47,12.47,0,0,0-1.284,7.465A32.46,32.46,0,0,0,835.248,300.086Z",
    transform: "translate(-564.529 -275.984)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M848.7,364.412c-1.471-6.621-3.31-8.829-3.31-8.829l-.7-.507-1.09-.785-.077-.057-.012.013-7.347-3.509-5.009-4.647a2.857,2.857,0,0,0-1.918-.76l-8.089-.061a2.848,2.848,0,0,0-2.281,1.114L816.3,349.71l-9.9,3.087-1.185.655s-3.31,4.415-3.31,8.461c0,.917-.209,3.63-.528,7.276h47.8A32.592,32.592,0,0,0,848.7,364.412Z",
    transform: "translate(-546.362 -309.043)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M717.339,438.043H631.521a10.693,10.693,0,0,1-10.681-10.681V368.584A10.693,10.693,0,0,1,631.521,357.9h85.818a10.693,10.693,0,0,1,10.681,10.681v58.778a10.693,10.693,0,0,1-10.681,10.681Zm-85.818-74.518a5.065,5.065,0,0,0-5.06,5.06v58.778a5.065,5.065,0,0,0,5.06,5.06h85.818a5.066,5.066,0,0,0,5.059-5.06V368.584a5.065,5.065,0,0,0-5.06-5.059Z",
    transform: "translate(-446.483 -316.032)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M720.469,363.564H634.652a8.165,8.165,0,0,0-8.154,8.154V430.5a8.161,8.161,0,0,0,8.154,8.149h85.817a8.161,8.161,0,0,0,8.154-8.149V371.718A8.165,8.165,0,0,0,720.469,363.564Z",
    transform: "translate(-449.613 -319.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 6.702,
    cy: 6.702,
    r: 6.702,
    transform: "translate(236.343 55.569)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 16.978,
    cy: 16.978,
    r: 16.978,
    transform: "translate(212.3 57.79)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 13.796,
    cy: 13.796,
    r: 13.796,
    transform: "translate(212.532 65.186)",
    fill: "#ffe5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M712.559,401.465a15.8,15.8,0,0,1,20.455,18.684c-7.245.2-14.748-.091-21.48-4.35l-.786-4.614-1.961,4.006c-2.431.415-4.837.688-6.7-1.5A16.136,16.136,0,0,1,712.559,401.465Z",
    transform: "translate(-491.433 -339.664)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M778.4,366.523a13.708,13.708,0,0,1,13.487,5.261,15.5,15.5,0,0,1,1.831,14.543c-1.86,4.857-5.876,8.5-9.631,12.1s-7.535,7.616-8.662,12.693a14.148,14.148,0,0,0,10.71,16.87c-4.7.892-9.6,1.779-14.219.521s-8.842-5.347-8.577-10.126c.191-3.444,2.542-6.32,4.586-9.1a69.854,69.854,0,0,0,8.258-14.627c1.028-2.477,1.927-5.122,1.638-7.788a9.345,9.345,0,0,0-7.729-8l-1.233-1.731A12.3,12.3,0,0,1,778.4,366.523Z",
    transform: "translate(-525.307 -320.654)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M731.63,503.994c-.893-9.105-5.942-8.748-5.942-8.748l-13.332-2.6-5.839-9.7-14.659-.572-5.218,9.15-10.723,1.34-.009.152c-1.063.08-4.9.92-5.665,8.743-.072.719-.17,1.6-.295,2.614H731.67C731.657,504.239,731.643,504.114,731.63,503.994Z",
    transform: "translate(-473.65 -384.892)",
    fill: "#c780fa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupArtIcon);
export default __webpack_public_path__ + "static/media/group-art-icon.0c8750dd8f16d4234ba423f761a388b2.svg";
export { ForwardRef as ReactComponent };